// Shared Recharts theme tokens for dark mode.
//
// Use with:
//   import { DARK_CHART_TOKENS, darkTooltipContentStyle, darkTooltipItemStyle } from '../lib/charts-theme';
//   <CartesianGrid stroke={DARK_CHART_TOKENS.gridStroke} />
//   <XAxis tick={{ fill: DARK_CHART_TOKENS.axisColor, fontSize: 11 }} stroke={DARK_CHART_TOKENS.axisColor} />
//   <Tooltip contentStyle={darkTooltipContentStyle} itemStyle={darkTooltipItemStyle} />
//
// Colors mirror the CSS custom properties in tokens.css — update them here
// if the token palette shifts. (Recharts can't reach CSS vars — it needs
// literal color strings at JS time.)

export const DARK_CHART_TOKENS = {
  gridStroke: 'rgba(255, 255, 255, 0.06)',
  axisColor: '#6b7280', // --text-muted
  axisFontSize: 11,
  axisFontFamily: "'JetBrains Mono', monospace",

  // Primary lines / series — green family
  greenPrimary: '#22d47a',   // greeniq-500
  greenDeep: '#0f9c50',      // greeniq-700
  greenBright: '#3fe576',    // greeniq-400

  // Supporting series
  blue: '#60a5fa',           // info
  orange: '#f5a623',         // warning
  red: '#ff6b6b',            // error
  violet: '#a78bfa',

  // Rain bars — clearly blue so they stand out against the green turf palette
  rainBar: '#60a5fa',

  // Threshold/reference lines
  referenceLine: 'rgba(255, 255, 255, 0.18)',
} as const;

export const darkTooltipContentStyle: React.CSSProperties = {
  backgroundColor: '#1a2230',   // --bg-card-elevated
  border: '1px solid rgba(255, 255, 255, 0.14)', // --border-strong
  borderRadius: 8,
  boxShadow: '0 12px 16px -4px rgba(0, 0, 0, 0.30)',
  color: '#f0f2f5', // --text-primary
  fontSize: 12,
  padding: '8px 10px',
};

export const darkTooltipItemStyle: React.CSSProperties = {
  color: '#f0f2f5',
};

export const darkTooltipLabelStyle: React.CSSProperties = {
  color: '#a0a8b4', // --text-secondary
  fontWeight: 600,
  fontSize: 11,
  marginBottom: 4,
};

export const darkLegendWrapperStyle: React.CSSProperties = {
  fontSize: 11,
  color: '#a0a8b4',
};
